import TabMenuBar from './src/tab-menu';

module.exports = TabMenuBar


// WEBPACK FOOTER //
// ./src/components/tab-menu/index.js